module.exports = __webpack_public_path__ + "static/media/wedding11.967ea034.jpg";